import script from './component-lib.esm6.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Paper', _vm._b({
    staticClass: "v-card",
    style: _vm.styles,
    attrs: {
      "component": _vm.component,
      "border-width": _vm.borderWidth
    }
  }, 'Paper', Object.assign({}, _vm.$props, _vm.$attrs), false), [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-c11861d4_0", {
    source: ".v-card[data-v-c11861d4]{background-color:var(--c-color);border:1px solid var(--c-border-color);border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));color:var(--g-color-on-bg);text-decoration:none;text-align:var(--c-text-align)}.v-card[data-v-c11861d4]>:last-child:not(.v-button):not(.v-chip){border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.v-card[data-v-c11861d4]>:first-child:not(.v-button):not(.v-chip){border-top-left-radius:inherit;border-top-right-radius:inherit}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-c11861d4";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Card = __vue_component__;
export { Card as default };